<template>
    <div>
        <template>
            <div id="allcontent">
                <div class="banner clearDiv">
                    <div class="banner-text clearDiv" >
                        <div>
                            <img class="bannerImg" src="https://file.cztooler.com/hammer/guanbannar.png" style="height: 30rem;width: 30rem;position: fixed;bottom: 13%;right: -3%;opacity: .7" alt="">
                        </div>
                        <div style="display:flex;align-items: center;font-size:2rem;height: 4rem; color: #333333;font-weight: bold;">
                            <img  style="width: 4rem; height: 4rem;line-height: 4rem;" src="https://file.cztooler.com/hammer/logo.png"/>
                            <span style="display: inline-block;margin-left: 1rem">
                                锤子工具人
                            </span>
                        </div>
                        <br>
                        <el-row>
                        </el-row>
                        <el-row style="margin: 7rem 0 6rem 0;">
                            <span style="font-size: 4rem;font-weight: bold;display: inline-block;color: #07c160;">你的微信工具助手</span>
                            <p style="font-size: 1.3rem;font-weight: bold;color: #07c160;margin-top: 1rem">投票、抽奖、预约、尺子、换装秀等几十个小工具人，扫码即用</p>
                        </el-row>
                        <el-row>
                            <el-image
                                    style="width: 10rem; height: 10rem;margin-bottom: 2rem;border-radius: 2%"
                                    :src="require('../assets/images/sy.png')"
                                    :preview-src-list="srcList">
                            </el-image>
                        </el-row>
<!--                        <br>-->
                        <el-row>
                            <p style="font-family: 'Microsoft Himalaya';font-size: 1.1rem;">请使用微信扫码体验</p>
                        </el-row>
                    </div>
                    <div style="display: flex;justify-content: space-between;position: absolute;top: 10%;right: 20%">
                        <template>
                            <el-carousel indicator-position="none" :interval="4000" type="card" height="42rem" style="width: 40rem">
                                <el-carousel-item  v-for="item in styleNew"  :style="item" style="background-repeat: no-repeat;background-size: 100% 100%;background-color:transparent;">
                                </el-carousel-item>
                            </el-carousel>
                        </template>
                    </div>
                </div>
                <div class="footerThis">
                    <span class="footerText">Copyright © 2021成都瓜甜网络科技有限公司
                        <span class="goto" @click="gotobeian">蜀ICP备2021002240号</span>

                    </span>
                </div>
            </div>

        </template>
    </div>
</template>

<script >
    export default {
        name: "shouye",
        components:{},  //要用的组件
        data() {
            return {
                // textStyle:{backgroundImage:"url('https://p1-q.mafengwo.net/s10/M00/5E/7B/wKgBZ1mC9HaAK_QIAAh1pr4J_V417.jpeg?imageMogr2%2Fthumbnail%2F%21636x480r%2Fgravity%2FCenter%2Fcrop%2F%21636x480%2Fquality%2F90')"},
                textStyle:{backgroundImage:"url('https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=793412436,1020579333&fm=11&gp=0.jpg')"},
                // textStyle:{backgroundImage:"url('../assets/images/dragShow.jpg')"},
                srcList:[require('../assets/images/sy.png')],
                circleUrl:"https://file.cztooler.com/hammer/logo.png",
                qrcode:'../assets/images/a2.jpg',
                xuanData:[],
                buyThisone:false,
                radio: 3,
                styleNew:[
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler1.png')"},
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler2.png')"},
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler3.png')"},
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler4.png')"},
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler5.png')"},
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler6.png')"},
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler7.png')"},
                    {backgroundImage:"url('https://file.cztooler.com/hammer/cztooler8.png')"},
                ],
            }
        },
        methods: {
            gotobeian(){
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
            }
        },
        computed:{
        },
        created() {
        }
    }


</script>

<style lang="less" scoped>
    .headertext{
        background-color: #f2f5f8;
        border: #FE730C 1px solid;
        height: 5rem;
        display: flex;
        /*justify-content: center;*/
        align-items: center;
    }
    .banner{
        position: relative;
        background-color: #f2f5f8;
        height: 92vh;
        .banner-text{
            z-index: 10;
            position: absolute;
            top: 10%;
            left: 20%;
        }
    }
    .footerThis{
        height:8vh;
        background-color: #f2f5f8;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .footerText{
        color: #999999;
        font-size: 1.1rem;

    }
    .goto{
        cursor: pointer;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }

    .searchinput{
        width: 40rem;
        margin-top: 1rem;
    }
    .selectbanner{
        border-radius: 1rem;
        padding: 2rem 2rem;
        background-color: rgba(62, 41, 30, 0.57);
        width: 50rem;
        .text{
            color: white;
        }
    }

    .item{
        /*border: #FE730C 2px solid;*/
        /*height: 25rem;*/
        /*width: 50rem;*/
        .item-chid{
            /*position: relative;*/
            h3{
                display: flex;
                position: absolute;
                top: 22rem;
                left: 0;
                right: 0;
                margin: 0 auto;
                font-size: 2.6rem;
                font-weight: 700;
                color: white;
                justify-content: center;
                align-items: center;
            }

            /*border: #409EFF 2px solid;*/
            /*height: 30rem;*/
        }
    }

    .hotelList{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;

    }

    .header{
        position: relative;
        .dropdown{
            position: absolute;
            top: .5rem;
            right: 0;
        }
    }
    .clearDiv :after{
        content: '';
        display: block;
        clear: both;
    }

</style>
